import { ServiceNameEnum, ServiceType } from '@Types/index';

import SERVICES from '../mapping/services.json';
import { PolicyType } from '@Types/app';

export const SERVICE_TYPES = SERVICES.serviceTypes as {
  name: ServiceNameEnum;
  order: number;
  id: number;
}[];

/**
 * frontend service name map to id, such as
 * ServiceNameEnum.ExchangeInline => 82
 */
export const SERVICE_NAME_ID_MAP = SERVICE_TYPES.reduce(
  (acc, val) => {
    acc[val.name] = val.id;
    return acc;
  },
  {} as { [key: string]: number }
) as { [key in ServiceNameEnum]: number };

/**
 * frontend service name map to order
 */
export const SERVICE_NAME_ORDER_MAP = SERVICE_TYPES.reduce(
  (acc, val) => {
    acc[val.name] = val.order;
    return acc;
  },
  {} as { [key: string]: number }
) as { [key in ServiceNameEnum]: number };

/**
 * service id map to frontend service name
 */
export const SERVICE_ID_NAME_MAP = SERVICE_TYPES.reduce(
  (acc, val) => {
    acc[val.id] = val.name;
    return acc;
  },
  {} as { [key: number]: string }
) as { [key: number]: ServiceNameEnum };

const _SERVICE_NAME_ARRAY: [string, ServiceNameEnum][] = [
  ['Exchange Online', ServiceNameEnum.Exchange],
  ['SharePoint Online', ServiceNameEnum.SharePoint],
  ['OneDrive', ServiceNameEnum.OneDrive],
  ['box', ServiceNameEnum.Box],
  ['gmail', ServiceNameEnum.Gmail],
  ['Gmail Inline', ServiceNameEnum.GmailInline],
  ['dropbox', ServiceNameEnum.Dropbox],
  ['googledrive', ServiceNameEnum.GoogleDrive],
  ['salesforce_sandbox', ServiceNameEnum.SalesforceSandbox],
  ['salesforce_production', ServiceNameEnum.SalesforceProduction],
  ['teams', ServiceNameEnum.Teams],
  ['teams_chat', ServiceNameEnum.TeamsChat],
  ['Exchange Server', ServiceNameEnum.ExchangeServer],
  ['Exchange Inline', ServiceNameEnum.ExchangeInline],
  [
    'Microsoft Identity Protection',
    ServiceNameEnum.MicrosoftIdentityProtection,
  ],
  [
    'Microsoft Information Protection',
    ServiceNameEnum.MicrosoftInformationProtection,
  ],
];

/**
 * es service name map to frontend service name
 */
export const SERVICE_NAME_MAP = new Map<string, ServiceNameEnum>(
  _SERVICE_NAME_ARRAY
);

/**
 * @description es_service_name_to_policy_type
 */
export const ES_SERVICE_NAME_TO_POLICY_TYPE = new Map<string, PolicyType>([
  ['Exchange Online', PolicyType.Exchange],
  ['SharePoint Online', PolicyType.SharePoint],
  ['OneDrive', PolicyType.OneDrive],
  ['box', PolicyType.Box],
  ['gmail', PolicyType.Gmail],
  ['Gmail Inline', PolicyType.GmailInline],
  ['dropbox', PolicyType.Dropbox],
  ['googledrive', PolicyType.GoogleDrive],
  ['salesforce_sandbox', PolicyType.SalesforceSandbox],
  ['salesforce_production', PolicyType.SalesforceProduction],
  ['teams', PolicyType.Teams],
  ['teams_chat', PolicyType.TeamsChat],
  // ['Exchange Server', PolicyType.ExchangeServer],
  ['Exchange Inline', PolicyType.ExchangeInline],
]);

/**
 * @description get service name in es
 * @returns
 */
export function getServiceNameByValue(value: ServiceNameEnum): string {
  //eslint-disable-next-line
  // @ts-ignore
  for (const [key, val] of SERVICE_NAME_MAP.entries()) {
    if (val === value) {
      return key;
    }
  }
  return '';
}

/**
 * @description get service names in es
 * @returns
 */
export function getServiceNamesByValues(values: ServiceNameEnum[]): string[] {
  const services = values.filter((item) => isServiceName(item));
  return services.map((value) => getServiceNameByValue(value));
}

/**
 * @description check name is ServiceNameEnum or not
 */
export function isServiceName(name: string): boolean {
  return (Object.values(ServiceNameEnum) as string[]).includes(name);
}

export function isServiceNameInES(name: string): boolean {
  return SERVICE_NAME_MAP.get(name) !== undefined;
}

export const getSortedServiceIds = (serviceIds: number[]) => {
  return SERVICE_TYPES.filter((x) => serviceIds.includes(x.id))
    .sort((a, b) => a.order - b.order)
    .map((x) => x.id);
};

export const getServiceNamesMapping = (
  sources: ServiceType[],
  mapping: number[]
): ServiceNameEnum[] => {
  const target: ServiceNameEnum[] = [];
  sources.forEach((source) => {
    if (mapping.indexOf(source['id']) > -1) {
      target.push(source['name']);
    }
  });
  return target;
};

export function convertNumToService(num: number) {
  for (const svc of Object.values(SERVICES.serviceTypes)) {
    if (svc.id === num) {
      return svc.name;
    }
  }
  return null;
}
